import * as React from 'react';
import { isMacOs } from 'react-device-detect';
import styled from 'styled-components';

import { color, fontSize, radius, spacing } from 'common/lib/theme/dynamic';

const Root = styled.kbd`
  color: ${({ theme }) => theme.color.textLight};
  font-family: inherit;
  font-size: ${({ theme }) => theme.fontSize.small};
`;

type Props = {
  /** The shortcut text (use "mod" for modifier key, it will be changed depending on user's platform) */
  text: string | string[];
  className?: string;
};

const KeyboardShortcut = ({ text, className }: Props) => {
  const arrayText = Array.isArray(text) ? text : text.split(' ');
  const parsedText = arrayText.map((t) => t.replace(/mod/gi, isMacOs ? '⌘' : 'Ctrl + '));
  return (
    <Root className={className}>
      {parsedText.map((t) => (
        <span key={t}>{t}</span>
      ))}
    </Root>
  );
};

/** Variant of {@link KeyboardShortcut} that displays the shortcut keys in small boxes. */
export const BlockyKeyboardShortcut = styled(KeyboardShortcut)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing.xxxsmall};

  > span {
    color: ${color.pureWhite};
    border: 1px solid ${color.gray9};
    border-radius: ${radius.small};
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${fontSize.xsmall};
  }
`;

export default KeyboardShortcut;
